import Section from "../Section"
import styles from "./Hero.module.scss"
import Image from "../Image"
import cx from "classnames"
import Link from "../Link"

const Hero = ({ data }) => {
  const {
    teaser,
    headline,
    subline,
    text,
    links,
    image,
    image_position: imagePosition,
  } = data
  return (
    <Section>
      <div className={styles.hero}>
        <div className={styles.bg} />
        <div className="container relative flex w-full flex-col items-center lg:flex-row lg:justify-between lg:gap-16 px-0">
          <div className={styles.imageWrapper}>
            {image && (
              <Image
                alt={image?.alt}
                src={image?.permalink}
                fill
                style={{
                  objectFit: "cover",
                  objectPosition: `${image?.focus_css || "center"}`,
                }}
              />
            )}
          </div>

          <div className={cx(styles.contentWrapper, {})}>
            {teaser && (
              <div
                className={styles.teaser}
                dangerouslySetInnerHTML={{ __html: teaser }}
              />
            )}
            {headline && (
              <h2
                className={styles.headline}
                dangerouslySetInnerHTML={{ __html: headline }}
              />
            )}
            {subline && (
              <div
                className={styles.subline}
                dangerouslySetInnerHTML={{ __html: subline }}
              />
            )}
            {text && (
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
            {links?.length > 0 && (
              <div className={styles.links}>
                {links.map((link, i) => (
                  <Link key={i} link={link} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default Hero
